module.exports = __webpack_public_path__ + "static/media/Van.58964182.png";